import React from "react";
import { Card, Col, Form, Input, Row, Select, Space, theme } from "antd";
import { UserOutlined, IdcardOutlined } from "@ant-design/icons";
import roleOptions from "../../../Util/constants";
import { EmployeeDetails } from "../../../serviceoperation/entity/EmployeeOperationEntity";

interface Props {
  employee: EmployeeDetails | null;
  form: any; // FormInstance from antd (kept any to avoid extra imports in canvas). Replace with FormInstance when integrating.
  initialValues: Record<string, unknown> | undefined;
  isEditing: boolean;
}

const PersonalInfoForm: React.FC<Props> = ({
  employee,
  form,
  initialValues,
  isEditing,
}) => {
  const { token } = theme.useToken();

  return (
    <Card
      title={
        <span>
          <UserOutlined style={{ color: token.colorPrimary }} />{" "}
          <span style={{ marginLeft: 8 }}>Personal Information</span>
        </span>
      }
      size="small"
      style={{ marginBottom: 16 }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        disabled={!isEditing}
      >
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="firstName"
                label="First Name"
                rules={[{ required: true, message: "Please enter first name" }]}
              >
                <Input placeholder="First name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[{ required: true, message: "Please enter last name" }]}
              >
                <Input placeholder="Last name" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item name="employeeID" label="Employee ID">
            <Input disabled prefix={<IdcardOutlined />} />
          </Form.Item>

          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: "Please select role" }]}
          >
            <Select
              options={roleOptions.map((r) => ({
                label: r.label,
                value: r.value,
              }))}
              showSearch
            />
          </Form.Item>
        </Space>
      </Form>
    </Card>
  );
};

export default PersonalInfoForm;
